<template>
  <v-container fluid>
    <vue-headful :title="`Enterprise - Halalize for Business`" />
    <v-layout class="mb-3">
      <v-flex xs12 md4 class="px-2">
        <el-card class="box-card">
          <h4>ยอดขายสุทธิ</h4>
          <div>
            <span class="display-1">{{amount.food_amount| numFormat('0,0.00')}}</span>
            <span class="ml-2">บาท</span>
          </div>
        </el-card>
      </v-flex>
      <v-flex xs12 md8 class="px-2"></v-flex>
    </v-layout>
    <v-layout class="mb-3">
      <v-flex xs12 md12 class="px-2">
        <el-card class="box-card">
          <apexchart height="220" type="area" :options="saleOptions" :series="saleSeries"></apexchart>
        </el-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Service from "../../services";
import moment from "moment";

export default {
  components: {},
  props: ["reference"],
  data() {
    return {
      loading: null,
      saleOptions: {
        chart: {
          id: "monthly-sale",
          toolbar: {
            show: false
          },
          type: "bar",
          height: 200
        },
        stroke: {
          curve: "straight",
          width: 1
        },
        xaxis: {
          categories: [1],
          labels: {
            rotate: -45
          }
        },
        colors: ["#e8711a", "#f5912f"],
        fill: {
          colors: ["#e8711a", "#f5912f"]
        }
      },
      saleSeries: [
        {
          name: "sale",
          data: []
        }
      ],
      amount: { food_amount: 0 }
    };
  },
  created() {
    let params = {
      begin: moment()
        .startOf("month")
        .format("YYYY-MM-DD"),
      end: moment().format("YYYY-MM-DD")
    };

    var queryString = Object.keys(params)
      .map(key => key + "=" + params[key])
      .join("&");

    Service.Enterprise.getSaleReport(this.reference, queryString).then(res => {
      let dates = [];

      var loop = new Date(params.begin);
      while (loop <= new Date(params.end)) {
        dates.push({ title: moment(loop).format("YYYY-MM-DD"), value: 0 });
        var newDate = loop.setDate(loop.getDate() + 1);
        loop = new Date(newDate);
      }

      res.data.map(item => {
        let index = dates.findIndex(x => x.title == item.date);
        dates[index].value =
          parseFloat(item.food_amount) + parseFloat(item.vat_amount);
      });
      let sales = [];

      let dates_text = [];
      let values = [];
      dates.map(item => {
        dates_text.push(moment(item.title).format("DD MMM"));
        values.push(item.value);
      });

      this.saleOptions = {
        ...this.saleOptions,
        xaxis: {
          categories: dates_text,
          labels: {
            rotate: -90
          },
          tickPlacement: "on"
        }
      };

      this.saleSeries = [{ name: "ยอดขาย", data: values }];
      this.amount.food_amount = res.data.reduce(
        (a, b) => +a + +parseFloat(b.food_amount) + parseFloat(b.vat_amount),
        0
      );
    });
  }
};
</script>